import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import Select from 'react-select';

import BackBtn from '../../../components/UI/BackBtn';
import { styledTable, styledTableHeading, tableIcons } from '../../../helpers';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../../helpers/table';
import useAPI from '../../../hooks/useAPI';

export default function ExpenseTypes() {
  const api = useAPI();

  const [expenseTypes, setExpenseTypes] = useState([]);
  const [agrs, setAgrs] = useState([]);
  const [kvrs, setKvrs] = useState([]);

  useEffect(async () => {
    const respExpenseTypes = await api.get('/mng/expenseTypes');

    if (respExpenseTypes && !respExpenseTypes.error) {
      setExpenseTypes(respExpenseTypes);
    }

    const respAgrs = await api.get('/mng/cost/agrs');

    if (respAgrs && !respAgrs.error) {
      setAgrs(respAgrs);
    }

    const respKvrs = await api.get('/mng/cost/kvrs');

    if (respKvrs && !respKvrs.error) {
      setKvrs(respKvrs);
    }
  }, []);

  const mapKvrsToOptions = (kvrs) => (kvrs ? kvrs.map((k) => ({ label: `${k.num} ${k.name}`, value: k.id })) : []);
  const onKvrMultiselectChange = (selectedOptions, onChangeHandler) => {
    const newVals = kvrs.filter((k) => selectedOptions.map((sO) => sO.value).includes(k.id));
    onChangeHandler(newVals);
  };

  const getColumns = () => [
    {
      title: 'Вид расхода',
      field: 'name',
      filterCellStyle: { minWidth: '300px' },
    },
    {
      title: 'КВР',
      field: 'costKvrs',
      filterCellStyle: { minWidth: '80%' },
      render: (rowData) => <div style={{ whiteSpace: 'pre-wrap' }}>{rowData.costKvrs.map((kvr) => `${kvr.num}\t${kvr.name}`).join('\n')}</div>,
      editComponent: ({ rowData, value, onChange }) => (
        <Select
          placeholder=""
          isMulti
          menuPlacement="auto"
          options={mapKvrsToOptions(kvrs)}
          onChange={(selValues) => onKvrMultiselectChange(selValues, onChange)}
          value={mapKvrsToOptions(value)}
          closeMenuOnSelect={false}
          components={{ IndicatorSeparator: () => null, ClearIndicator: () => null }}
          styles={selectStyles}
        />
      ),
    },
  ];

  const handleSaveData = async (body, isNew) => {
    const resp = await api.post('/mng/expenseTypes/0', body);
    if (resp && !resp.error) {
      isNew
        ? await setExpenseTypes((prev) => [resp, ...prev])
        : await setExpenseTypes((prev) => prev.map((kvr) => (kvr.id === resp.id ? resp : kvr)));
      return true;
    }
    return false;
  };

  const handleRemoveData = async (body) => {
    const resp = await api.del(`/mng/expenseTypes/${body.id}`, body);
    if (resp && !resp.error) {
      await setExpenseTypes((prev) => prev.filter((kvr) => kvr.id !== resp.id));
      return true;
    }
    return false;
  };

  return (
    <section className="page admin-strats-page">
      <div className="container">
        <BackBtn />
        <div style={{ marginTop: 20 }}>
          <div style={styledTable}>
            <MaterialTable
              options={modifyDefaultOptions({
                actionsColumnIndex: -1,
                addRowPosition: 'first',
              })}
              title="Соответствие видов расходов КВР"
              icons={tableIconsModified}
              localization={localization}
              columns={getColumns()}
              data={expenseTypes}
              editable={{
                onRowAdd: (newData) =>
                  new Promise(async (resolve, reject) => {
                    const success = await handleSaveData(newData, true);
                    if (success) resolve();
                    else reject();
                  }),
                onRowUpdate: (newData, oldData) =>
                  new Promise(async (resolve, reject) => {
                    const success = await handleSaveData(newData);
                    if (success) resolve();
                    else reject();
                  }),
                onRowDelete: (oldData) =>
                  new Promise(async (resolve, reject) => {
                    const success = await handleRemoveData(oldData);
                    resolve();
                  }),
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

const selectStyles = {
  valueContainer: (provided) => ({ ...provided, flexDirection: 'column', alignItems: 'flex-start' }),
  multiValue: (provided) => ({ ...provided, flexDirection: 'row-reverse' }),
  multiValueLabel: (provided) => ({ ...provided, whiteSpace: undefined }),
};
